import React from "react";
import Icon from "../../../../../../../bus-dweb/src/stories/core-components/IconsSelector";
import * as S from './LastMinute.styles';

const LastMinute = ({ nitro_offer }) => {
    const { title, avl_seats, tot_disc, text } = nitro_offer

    return (
        <>
            <S.LastDealSection>
                <S.LastDealWrapper>
                    <S.LastMin>
                        <Icon name="TimerIcon" styleProps={{ fill: '#fff', width: '10px', height: '10px' }}></Icon>
                        <S.LastMinTitle>{title || 'Last Minute Sale'}</S.LastMinTitle>
                    </S.LastMin>
                    {avl_seats && tot_disc ?
                        <S.PersuasionText>
                            Last {avl_seats} seats left with <b>{tot_disc}% off</b>
                        </S.PersuasionText>
                        : text ? <S.PersuasionText>{text}</S.PersuasionText> : <></>}
                </S.LastDealWrapper>
            </S.LastDealSection>
        </>
    );
};

export default LastMinute;
